import React from 'react';
import { Row, Col, Button, FormControl } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'
import { commifyNumber } from '../../utils/utilities'
import ConvertibleText from '../../components/shared/ConvertibleText'
import classNames from 'classnames'
import Cleave from 'cleave.js/dist/cleave-react'

class Deductible extends React.Component {
  constructor(props) {
    super(props)

    this.onBlurTextHandler = this.onBlurTextHandler.bind(this);
    this.onBlurValueHandler = this.onBlurValueHandler.bind(this);
  }

  onBlurTextHandler(name) {
    this.props.onBlurHandler(this.props.id, name, this.props.text);
  }

  onBlurValueHandler(priceValue) {
    const lable = Object.keys(priceValue)[0];
    priceValue[lable] = !!priceValue[lable] ? priceValue[lable] : '0';
    const text = `$${commifyNumber(priceValue[lable])}`;
    this.props.onBlurHandler(this.props.id, lable, text);
  }

  render() {
    const { isModified, name, text, manuallySetPricing, id, onDeleteShow } = this.props
    return (
      <div>
        <Row >
          <Col xs={8} md={6}>
            <div className="premiumGrid">
              <span className="h5">
                <input
                  className="list-text form-control"
                  type='text'
                  autoComplete={false}
                  defaultValue={name}
                  onBlur={(event) => this.onBlurTextHandler(event.target.value)}
                  placeholder='Enter Deductible'
                />
              </span>
              <span className="h4">{
                isModified
                  ? <Loading width="23px" height="23px" />
                  : <ConvertibleText
                    manuallySetPricing={manuallySetPricing}
                    value={{
                      name: name,
                      text: text
                    }}
                    onBlurHandler={this.onBlurValueHandler}
                  />
              }
              </span>
            </div>
          </Col>
          <Col>
          {onDeleteShow &&
          <Button className="list-minus" onClick={() => this.props.onDelete(id)}>
            <i className="fa fa-minus-circle fa-lg" title="Delete Deductible" aria-hidden="true" />
          </Button>
        }
          </Col>
        </Row>        
      </div>
    )
  }
}

export default Deductible